export default __webpack_public_path__ + "static/02_嘉宾头像_唐刘-e390e78a7e62803c88b187af2dd5bb9a.png";